import Vue from "vue";
import { trackGoogleEvent } from "@/mixins/eventTracking";
import { checkDateInput } from "@/mixins/checkDateInput";

Vue.mixin({
  methods: {
    trackGoogleEvent,
    checkDateInput,
  },
});
